// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"c18dbbf6","913":"dbf66bd8"}[chunkId] + ".chunk.css";
};